import {Link} from "react-router";

type LinqProps = React.ComponentProps<typeof Link>;

export function Linq(props: LinqProps) {
    return <Link {...props} onClick={e => e.stopPropagation()}>{props.children}</Link>
}
